import { Chip, TableCell, TableRow, Tooltip, Typography } from "@mui/material";

import type { OutboundNetworkInvite } from "../../../types";

interface Props {
  invite: OutboundNetworkInvite;
}

export function OutboundInviteRow(props: Props) {
  const { invite } = props;
  const isSupplierInvite = invite.invite_target_type === "SUPPLIER";

  return (
    <TableRow>
      <TableCell>
        <Typography variant="body1">
          {invite.target_user_first_name} {invite.target_user_last_name}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body1">{invite.target_company_name}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">{invite.target_user_email}</Typography>
      </TableCell>
      <TableCell>
        <Tooltip
          title={
            isSupplierInvite
              ? "Invite to join your supplier network"
              : "Invite to join your customer network"
          }
        >
          <Chip
            label={isSupplierInvite ? "Supplier" : "Customer"}
            size="small"
            color={isSupplierInvite ? "primary" : "secondary"}
            variant="outlined"
          />
        </Tooltip>
      </TableCell>
      <TableCell>
        <Chip label="Pending" variant="outlined" size="small" color="warning" />
      </TableCell>
      <TableCell>
        <Typography variant="body2">
          {new Date(invite.created_at).toLocaleDateString()}
        </Typography>
      </TableCell>
    </TableRow>
  );
}
